import { thriveContent } from './thriveContent';
import { getWorkflowState } from './workflowState';
import { workflows } from './workflow';

export const standardProgram = {
  thriveContent: thriveContent,
  workflow: workflows,
  getWorkflowState,
};
